import { ClientConfigResponse } from '@dav-model/api/response/client-config.response.model';
import { Action } from '@ngrx/store';
import { ApplicationCode } from 'environments/environment.model';

/**
 * When User initially visits our page, UI will
 * get all images and css
 */

export const GET_INITIAL_LAYOUT = '[Config] GET INITIAL LAYOUT';
export const GET_INITIAL_LAYOUT_SUCCESS = '[Config] GET INITIAL LAYOUT SUCCESS';
export const TEST_LAYOUT = '[Admin] TEST LAYOUT';
export const RESET_LAYOUT = '[Admin] RESET LAYOUT';
export const TOGGLE_DEALER_VIEW = '[Config] TOGGLE DEALER VIEW';
export const CONFIG_FAILURE = '[Config] CONFIG FAILURE';

export const GET_PRODUCT_IMAGES = '[Config] GET PRODUCT IMAGES';
export const GET_PRODUCT_IMAGES_SUCCESS = '[Config] GET PRODUCT IMAGES SUCCESS';

export const SET_OKTA_LOADING = '[Config] SET OKTA LOADING';
export const RESET_OKTA_LOADING = '[Config] RESET OKTA LOADING';

export class GetInitialLayoutAction implements Action {
  readonly type = GET_INITIAL_LAYOUT;

  constructor(public application: ApplicationCode) {}
}

export class GetInitialLayoutSuccessAction implements Action {
  readonly type = GET_INITIAL_LAYOUT_SUCCESS;

  constructor(public payload: ClientConfigResponse) {}
}

export class GetProductImagesAction implements Action {
  readonly type = GET_PRODUCT_IMAGES;
}

export class SetOktaLoadingAction implements Action {
  readonly type = SET_OKTA_LOADING;
}

export class ResetOktaLoadingAction implements Action {
  readonly type = RESET_OKTA_LOADING;
}

export class GetProductImagesSuccessAction implements Action {
  readonly type = GET_PRODUCT_IMAGES_SUCCESS;

  constructor(public payload: any) {}
}

export class TestLayoutAction implements Action {
  readonly type = TEST_LAYOUT;

  constructor(public payload: ClientConfigResponse) {}
}

export class ResetLayoutAction implements Action {
  readonly type = RESET_LAYOUT;
}

export class ToggleDealerViewAction implements Action {
  readonly type = TOGGLE_DEALER_VIEW;

  constructor(public payload: boolean) {}
}

export class ConfigFailureAction implements Action {
  readonly type = CONFIG_FAILURE;

  constructor(public payload: string) {}
}

export type All =
  | GetInitialLayoutAction
  | GetInitialLayoutSuccessAction
  | ToggleDealerViewAction
  | ConfigFailureAction
  | TestLayoutAction
  | ResetLayoutAction
  | GetProductImagesAction
  | GetProductImagesSuccessAction
  | SetOktaLoadingAction
  | ResetOktaLoadingAction;
